import React, { useMemo } from "react";
import {
  BonusDrawContainer,
  BonusDrawContent,
  BonusDrawHeader,
  BonusDrawImage,
  BonusDrawInfo,
  BonusDrawMedia,
  Button,
  SubtitleText,
  TitleText,
} from "raffle-house-uikit";
import {getDaysLeft} from "../../helpers/getDaysLeft";

import "./style.scss";

export default function BonusDraw({ onCTAClick, bonusDraw, videoData, content }) {
  const image = content.mainImage;
  const badgePrice = content.badgePrice;

  const daysLeft = bonusDraw.endAt ? getDaysLeft(bonusDraw.endAt) : 10;

  const badgeBaseUrl = process.env.REACT_APP_AWS_S3_URL + 'icons/' || '';

  const badge = useMemo(() => {
    if (daysLeft <= 7) {
      const badgeName = daysLeft === 1 ? 'closing3.svg' : daysLeft === 2 ? 'closing2.svg' : 'closing.svg';
      return (
        <div className="bonus-draw__badge bonus-draw__badge--top">
          <img decoding="async" loading="lazy" src={`${badgeBaseUrl}${badgeName}`} alt="Early Bird draw badge" />
        </div>
      );
    } else
      return (
        <div className="bonus-draw__badge">
          <span className="bonus-draw__badge-price">{badgePrice}</span>
          <img decoding="async" loading="lazy" src={content.badgeUrl} alt="Early Bird draw badge" />
        </div>
      );
  }, [daysLeft]);

  const poster = videoData && videoData.videoPreviewUrl && videoData.videoPreviewUrl.length ? videoData.videoPreviewUrl : null;
  const video = videoData && videoData.videoUrl && videoData.videoUrl.length ? videoData.videoUrl : null;
  // const poster =
  //   "https://raffle-house-production.s3.eu-west-1.amazonaws.com/bonus-draw/video/01.11.2025/eb-preview.jpg";
  // const video =
  //   "https://raffle-house-production.s3.eu-west-1.amazonaws.com/bonus-draw/video/01.11.2025/eb.mp4";

  return (
    <BonusDrawContainer>
      <BonusDrawHeader>
        <TitleText isCentered as="h2" variant={"primary"} color="color-1">
          The {bonusDraw.profileTitle} Early Bird Draw
        </TitleText>
        <SubtitleText color="color-1" isCentered>
          {bonusDraw.metaDescription}
        </SubtitleText>
      </BonusDrawHeader>
      <BonusDrawContent>
        <BonusDrawInfo>
          <TitleText isCentered as="h3" variant={"primary"} color="color-2">
            {bonusDraw.metaTitle}
          </TitleText>
          <Button onClick={onCTAClick}>Enter now</Button>
        </BonusDrawInfo>
        <BonusDrawMedia>
          {video ? (
            <video
              id="early-bird-draw-video"
              loop
              autoPlay={true}
              muted
              playsInline
              data-wf-ignore="true"
              data-object-fit="cover"
              poster={poster}
            >
              <source src={video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <BonusDrawImage
              srcSet={`
              ${image.image800Url} 800w,
              ${image.image1600Url} 1600w,
              ${image.image2048Url} 2048w,
              ${image.image3840Url} 3840w,
            `}
              sizes={`(max-width: 800px) 800px, (max-width: 1600px) 1600px, (max-width: 2048px) 2048px, 3840px`}
              src={image.image1600Url}
              alt={`The ${bonusDraw.profileTitle} Bonus Draw`}
            />
          )}
          {badge}
        </BonusDrawMedia>
      </BonusDrawContent>
    </BonusDrawContainer>
  );
}
